import { Component, OnInit, ElementRef, Renderer2, AfterViewInit, ViewChildren, QueryList, ChangeDetectionStrategy, NgZone, ChangeDetectorRef, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { DeviceService } from '../../services/device/device.service';
import {  PopoverController, ModalController} from '@ionic/angular';
import { BrandOfflineService } from '../../services/brand/brand.service';
import { Brand } from '../../classes/brand/brand.class';
import { ActivityService } from '../../services/activity/activity.service';
import { AppointmentActivity } from '../../classes/activity/appointment.activity.class';
import { MeetingDataService, UpdateMeetingPayload } from '../../data-services/meeting/meeting.data.service';
import { DiskService } from '../../services/disk/disk.service';
import { GlobalErrorHandler } from '../../services/error-handler/error-handler-service';
import { NavigationService, PageName } from '../../services/navigation/navigation.service';
import { UIService } from '../../services/ui/ui.service';
import { AuthenticationService } from '../../services/authentication.service';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '../../classes/authentication/user.class';
import { FooterService } from '../../services/footer/footer.service';
import { NotificationService, ToastStyle } from '../../services/notification/notification.service';
import { TrackService, TrackingEventNames } from '../../services/logging/tracking.service';
import { TranslateService } from '@ngx-translate/core';
import { EmailActivity } from '@omni/classes/activity/email.activity.class';
import { EmailService } from '@omni/services/email-templates/email.service';
import { IndSectionHeaderViewDataModel } from '@omni/models/indSectionHeaderDataModel';
import { MainToolTemplateDetail, MainToolTemplateListSelectionType } from '@omni/models/mainToolTemplateDetail.model';
import { EventsService } from '@omni/services/events/events.service';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { BarcodeStatus, BarcodescannerService } from '@omni/services/barcodescanner/barcodescanner.service';
import { OmniAlertComponent } from '../shared/omni-alert/omni-alert.component';
import { AgendaFooterService } from '@omni/services/footer/agenda-footer.service';
import { SecondaryInfoEntityName } from '@omni/classes/sec-info-config/sec-info.class';
import { SecInfoConfigDataService } from '@omni/data-services/sec-info-config/sec-info-config-data-service';
import { MeetingActivityState } from '@omni/classes/activity/activity.class';
import { FormFieldType, IndFormFieldViewDataModel } from '@omni/models/indFormFieldDataModel';
import { Section } from '../activity/activities-details-pane/activities-details-pane';
import { cloneDeep, isEmpty, isEqual, sortBy, uniq, uniqBy } from 'lodash-es';

/**
 * Generated class for the ProductKeyMessagesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: 'product-key-messages',
  templateUrl: 'product-key-messages.html',
  styleUrls: ['product-key-messages.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})


export class ProductKeyMessagesComponent implements OnInit , AfterViewInit, OnDestroy {
  showKeyMessageArrowButtons: boolean;
  public spaceBetweenSlides: number;
  public slidePerView: number | string;
  public spaceBetween: number;
  public currentIndex: number;

  /** Store the previously saved products**/
  private previouslySavedProducts: any[] = [];
  showReorderIcon:boolean;
  activityProducts: Array<Brand> = [];
  products:Array<Brand> = [];
  tempProducts: Array<Brand> = [];
  private productKeyMessagesSaved:Array<Brand> = [];
  updateProductsFlag:boolean = false;
  brandsReordered:boolean = false;
  public brandIDs:Array<any>= new Array<any>();
  private currentSlider:any;
  @ViewChildren("roundInput") roundLabels:QueryList<ElementRef>;
  @ViewChildren('slider') keyMessageSlider:QueryList<any>;
  @Input() isReadOnlyJointMeeting:boolean = false;
  @Input() checkIfExternalChannelSelected:boolean = false;
  @Input() backgroundUploadInProgress: boolean;
  recognizer: any;
  productsKeyMessagesHeaderModel: IndSectionHeaderViewDataModel;
  contentBrand: Array<Brand> = [];
  brandProductsAfterSort: Brand[];
  productsAddedForcovisitor: any[] = [];
  private _productSortOrderMap: Map<string, number> | null = null;
  private ngDestroy$ = new Subject<boolean>();
  @Input() isProductRequired: boolean;
  @Output() openKeyMessageSentiment = new EventEmitter();
  private scannedProduct;
  public filteredSavedProducts: Array<Brand> = [];
  public productsSearchField: IndFormFieldViewDataModel;
  private productSourceData:any = [];

  constructor(
    public events:EventsService,
    public device:DeviceService,
    private elRef:ElementRef,
    public activityService: ActivityService,
    private renderer:Renderer2,
    private meetingDataService: MeetingDataService,
    private emailService: EmailService,
    private diskService:DiskService,
    public globalErrorHandler:GlobalErrorHandler,
    private _cd: ChangeDetectorRef,
    private _ngZone: NgZone,
    public uiService: UIService,
    public navService: NavigationService,
    public authService: AuthenticationService,
    public footerService: FooterService,
    public notificationService: NotificationService,
    public popoverCtrl: PopoverController,
    public modalCtrl: ModalController,
    public trackingService: TrackService,
    private translate : TranslateService,
    private brandService: BrandOfflineService,
    private barcodescannerService : BarcodescannerService,
    private readonly agendaFooterService: AgendaFooterService,
    private secondaryInfoService: SecInfoConfigDataService,
  ) {
    if(this.device.isMobileDevice){
      this.slidePerView = 2;
      this.spaceBetween = -5;
    }else{
      //web
      this.slidePerView =  4;
      this.spaceBetween = -10;
   }
  }

  private _activitySelectedEventHandler = () => {
    this.tempProducts.map(product => {
      //Remove isSelected & isAutoSelected from each product to reset the ui
      product.isSelected = undefined;
      product.isAutoSelected = undefined;

      product.keyMessages.map(keyMessage => {
        keyMessage.isAutoSelected = undefined;
        keyMessage.isSelected = undefined;
      })
    })

    //CWD-3765, disble the save button when user tap on a new meeting activity
    this.updateProductsFlag = false;
    this.getProductMessageHeader();
    this.updateFilteredSavedProducts();
  };

  private _activityProductsCreatedEventHandler = (brands:Array<Brand>) => {
    /**
    * this is a reference to master brands with isSelected and isAutoSelected set accordingly
    * based on the meeting activityProduct from dynamics
    */
    this.products = cloneDeep(sortBy(brands, [function (o) { return o.isSelected || o.isAutoSelected; }]));
    const savedProducts = cloneDeep(brands.filter(o => { return o.isSelected || o.isAutoSelected }));
    
    if (savedProducts.length) {
      this.tempProducts = uniqBy(savedProducts, 'ID');
    } else {
      this.tempProducts = [];
    }

    if ((this.activityService.selectedActivity as AppointmentActivity)?.presentations?.length) {
      let addedContent = (this.activityService.selectedActivity as AppointmentActivity).presentations;
      if (!isEmpty(addedContent)) {
        addedContent.forEach(content => {
          if (!isEmpty(content.brands)) {
            this.activityService.selectedActivity.products?.forEach(brand => {
              if (content.brands[0]?.name === brand.name) {
                brand.isSelected = true;
                brand.isAutoSelected = true;
                this.contentBrand.push(brand);
              } else if ((content.brands[0] === brand.name)) {
                brand.isSelected = true;
                brand.isAutoSelected = true;
                this.contentBrand.push(brand);
              }
            });
          }
        });
      }

      if (!isEmpty(this.contentBrand)) {
        this.contentBrand = uniqBy(this.contentBrand, 'ID');
        this.contentBrand.forEach(item => {
          const index = this.tempProducts?.findIndex(tp => tp.ID === item.ID);
          if (index > -1) {
            this.tempProducts[index] = item;
          } else {
            this.tempProducts.push(item);
          }
        });
      }

      let selectedTemp = this.tempProducts.filter(o => {
        return o.isSelected || o.isAutoSelected      });
      if (selectedTemp.length) {
        this.tempProducts = uniqBy(selectedTemp.concat(this.tempProducts), 'ID')
      } else {
        this.tempProducts = uniqBy(this.tempProducts, 'ID')
      }
    }

    if(this.productsAddedForcovisitor.length && this.isReadOnlyJointMeeting){
      this.productsAddedForcovisitor.forEach(pro =>{
        this.tempProducts.push(new Brand(pro, pro.indskr_sequence, true));
        console.log("this.tempProducts",this.tempProducts)
      })
      this.tempProducts = uniqBy( sortBy(this.tempProducts, [function(o) { return o.isSelected || o.isAutoSelected; }]),'ID');
     }


    /** Filter activity products for the completed meeting before loading */
    this.filterCompletedActivityProducts();
    /* */

    this.getProductMessageHeader();
    this.updateFilteredSavedProducts();
    this.initProductsSearchField();
  };

  ngOnInit(): void {
    this.tempProducts = [];
    this.products = [];
    this.contentBrand = [];
    this.unsubscribeToEvents();
    this.subscribeToEvents();
    this.initDetails();
    this.getProductMessageHeader();

    this.translate.onLangChange.subscribe(data => {
      this.initDetails();
      this.getProductMessageHeader();
    });

    this.barcodescannerService.scanningInProgress = false;
  }

  private  initDetails = async () => {
    //when an activity is selected let's reset our data set but keep the general structure
   // this._activitySelectedEventHandler();
    this.updateProductsFlag = false;

    this.getProductMessageHeader();

    this.showKeyMessageArrowButtons = !(this.device.isNativeApp);
    this.showReorderIcon = true;

    if (this.activityService.selectedActivity.products /*&& !this.device.isOffline*/) {
      this.products = cloneDeep(this.activityService.selectedActivity.products);
      const savedProducts = this.products.filter(o => o.isSelected || o.isAutoSelected);
      const getUniqueProducts = (items: Brand[]) => uniqBy(items, 'ID');

      if (savedProducts.length) {
        this.tempProducts = getUniqueProducts([...savedProducts, ...this.contentBrand]);
      } else if (!savedProducts.length && this.contentBrand.length) {
        this.tempProducts = getUniqueProducts([...this.contentBrand]);
      } else {
        this.tempProducts = [];
      }
      this.previouslySavedProducts = cloneDeep(savedProducts);
    } else {
      //we are offline or the selected activity products is not in sync with MSE , and we need to retrieve from disk
      if (this.productKeyMessagesSaved.length !== 0) {
        console.log("Referenced . . .");
        this.products = this.productKeyMessagesSaved;
        this.tempProducts = sortBy(this.products, [function(o) { return o.isSelected || o.isAutoSelected; }]);
      } else {
        this.brandService.deSelectAll();
        const brands: Array<Brand> = cloneDeep(this.filteredBrands());
        //no details, make basic array
        let brand = brands.filter(value => {
          return value.isSelected === undefined || !value.isSelected;
        });
        brand.forEach((el, index) => el.priority = brands.length + index + 1);
        //sort the products and return it to UI
        //now sort the products based on the sequence(product priority) , if the sequence is not available default
        brands.sort((item1, item2) => {
          //sort criteria
          if (item1.priority && item2.priority) {
            return item1.priority - item2.priority;
          }
        });
        this.activityService.updateSelectedActivityProps({ products: brands });
        this.products = brands;
        this.products = sortBy(this.products, [function(o) { return o.name; }]);
      }
    }
    //if content added to the meeting
    if((this.activityService.selectedActivity as AppointmentActivity)?.presentations?.length){
      if (isEmpty(this.contentBrand)) {
        let addedContent = (this.activityService.selectedActivity as AppointmentActivity).presentations;
        const clonedBrands: Array<Brand> = cloneDeep(this.filteredBrands());        
        this.contentAdding(addedContent,  clonedBrands);
      }
      
      if (!isEmpty(this.contentBrand)) {
        this.contentBrand = uniqBy(this.contentBrand, 'ID');
        this.contentBrand.forEach(item => {
          const index = this.tempProducts?.findIndex(tp => tp.ID === item.ID);
          if (index > -1) {
            const currentPriority = this.tempProducts[index]?.priority;
            item.priority = currentPriority !== undefined ? currentPriority : item.priority;
            this.tempProducts[index] = item;
          } else {
            this.tempProducts.push(item);
          }
        });
      }
      this.tempProducts = uniqBy(this.tempProducts, 'ID');
    }

    /** Filter activity products for the completed meeting before loading */
    this.filterCompletedActivityProducts();
    /** */
    this.updateFilteredSavedProducts();
    this.initProductsSearchField();
    this._cd.detectChanges();
  }

  updateKeyMessagesSelection(products: Brand[]) {
    if (!isEmpty(products)) {
      products.forEach(product => {
        const index = this.tempProducts?.findIndex(tp => tp.ID === product.ID);
        if (index > -1) {
          this.tempProducts[index].priority = product.priority;
          if (product.keyMessages?.length > 0) {
            product.keyMessages.forEach(km => {
              if (km.isSelected) {
                const indexKeyMessage = this.tempProducts[index]?.keyMessages?.findIndex(d => d.ID === km.ID);
                if (indexKeyMessage > -1) {
                  this.tempProducts[index].keyMessages[indexKeyMessage].isSelected = true;
                }
              }
            });
          }
        }
      });
    } 
  }

  ngOnDestroy() : void {
    // this.unsubscribeToEvents();
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
    console.log('called ng destroy in product key msgs comp');
  }

  ngOnChanges() {
    this.initDetails();
    this.getProductMessageHeader();
  }

  // tslint:disable-next-line:prefer-function-over-method
  ngAfterViewInit():void{
  }

  subscribeToEvents() {

    this.events.observe('meetingCompleted').pipe(takeUntil(this.ngDestroy$)).subscribe((activity) => {
      this.initDetails();
      this.getProductMessageHeader();
    });
    this.events.observe('meetingReopened').pipe(takeUntil(this.ngDestroy$)).subscribe((activity) => {
      this.initDetails();
      this.getProductMessageHeader();
    });
    this.events.observe('userStateChanged').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.getProductMessageHeader();
    });
    this.events.observe('activities-pane:activitySelected').pipe(takeUntil(this.ngDestroy$)).subscribe(this._activitySelectedEventHandler);
    this.events.observe('user:activity_products_created').pipe(takeUntil(this.ngDestroy$)).subscribe(this._activityProductsCreatedEventHandler);
    
    this.events.observe('initActivityKeyMessages').pipe(takeUntil(this.ngDestroy$)).subscribe(async () => {
      await this.initDetails();
    });
    this.events.observe('contentIsAdded').pipe(debounceTime(300), takeUntil(this.ngDestroy$)).subscribe((addedContent) => {
      if (Array.isArray(addedContent) && addedContent.length > 0) {
        let brands: Array<Brand> = cloneDeep(this.filteredBrands());
        this.contentBrand = [];
        if ((this.activityService.selectedActivity as AppointmentActivity)?.activityProducts?.length) {
          this.contentAdding(addedContent, (this.activityService?.selectedActivity as AppointmentActivity).activityProducts)
        } else {
          this.contentAdding(addedContent, brands)
        }

        let isAddedProduct = false;
        if (!isEmpty(this.contentBrand)) {
          this.contentBrand = uniqBy(this.contentBrand, 'ID');
          this.contentBrand.forEach(item => {
            const index = this.tempProducts?.findIndex(tp => tp.ID === item.ID);
            if (index > -1) {
              this.tempProducts[index] = item;
            } else {
              this.tempProducts.push(item);
            }
          });
          isAddedProduct = true;
        }

        this.tempProducts = uniqBy(this.tempProducts, 'ID');
        if (!this.updateProductsFlag) {
          this.activityService.updateSelectedActivityProps({ products: this.tempProducts });
          this._activityProductsCreatedEventHandler(this.activityService.selectedActivity.products);
        }
        
        if(isAddedProduct) {
          console.log('isAddedProduct');
          this._saveProduct();
        }
        this._cd.detectChanges();
      }
    })

    this.events.observe('contentIsRemoved').pipe(takeUntil(this.ngDestroy$)).subscribe((removedContents: any) => {
      let indexOfRemoveContent;
      let isRemovedProduct = false;
      if (Array.isArray(removedContents) && removedContents.length > 0) {
        removedContents.forEach(removedContent => {
          if (removedContent?.brands && Array.isArray(removedContent.brands)) {
            removedContent.brands.forEach(brand => {
              indexOfRemoveContent = this.tempProducts.findIndex((pro) => ((pro.name === brand || pro.name === brand?.name || pro.ID === brand?.ID) && (pro.isSelected) && (pro.isAutoSelected)));
              if (indexOfRemoveContent > -1) {
                this.tempProducts.splice(indexOfRemoveContent, 1);
                isRemovedProduct = true;
              }
              if (!isEmpty(this.contentBrand)) {
                this.contentBrand = uniqBy(this.contentBrand, 'ID');
                const idx = this.contentBrand.findIndex(cb => ((cb.name === brand || cb.name === brand?.name || cb.ID === brand?.ID) && (cb.isSelected) && (cb.isAutoSelected)));
                if (idx > -1) {
                  this.contentBrand.splice(idx, 1);
                }
              }
            });
          }
        });
      }
      if (isRemovedProduct) {
        this._saveProduct();
      }
    })

    this.events.observe('savedProductsForCovisitor').pipe(takeUntil(this.ngDestroy$)).subscribe((pro: any[]) => {
      if (this.isReadOnlyJointMeeting) {
        this.productsAddedForcovisitor = pro ? pro.filter(pr => pr['productStructure'] != 3) : [];
      }
    });

    this.events.observe('activityproductkeymessagesupdated').pipe(takeUntil(this.ngDestroy$)).subscribe((brands: Array<Brand>)=> {
      if (brands && brands.length > 0) {
        this.updateKeyMessagesSelection(brands);
      }
    });
  }

 contentAdding(addedContent, brands) {
  let addedContentBrandsList = [];
  let addedContentBrandWithName = [];

  if (!isEmpty(addedContent)) {
    addedContent.forEach((content) => {
      if (!isEmpty(content.brands)) {
        addedContentBrandsList.push(...content.brands);
      }
    });
  }
  addedContentBrandsList = uniq(addedContentBrandsList);

  // Sometimes brands will have object with name property - resource case
  addedContentBrandsList.filter(addedContentBrand => addedContentBrand.name).forEach(ab => {
    if (ab.name) {
      addedContentBrandWithName.push(ab.name);
    }
  });
  addedContentBrandsList = uniq([...addedContentBrandWithName, ...addedContentBrandsList]);

  const clonedBrands = cloneDeep(brands);
  addedContentBrandsList.forEach(contentBrand => {
    this.contentBrand.push(
      ...clonedBrands.filter(brand => brand.name === contentBrand || brand.name === contentBrand?.name)
    );
  });

  if (!isEmpty(this.contentBrand)) {
    this.contentBrand = uniqBy(this.contentBrand, 'ID');

    // Set isSelected and isAutoSelected for brands
    this.contentBrand.forEach(brand => {
      brand.isSelected = true;
      brand.isAutoSelected = true;
    });

    // Update keyMessages for each content in addedContent
    addedContent.forEach(content => {
      if (!isEmpty(content.keyMessages) && !isEmpty(content.brands) && !isEmpty(this.contentBrand)) {
        // Only process brands in this.contentBrand that are actually in content.brands
        const relevantBrands = this.contentBrand.filter(brand =>
          content.brands.some(cb => {
            if (cb?.ID && brand?.ID) {
              return cb.ID === brand.ID;
            }
            if (cb?.name && brand?.name) {
              return cb.name === brand.name;
            }
            return cb === brand?.name;
          })
        );
        relevantBrands.forEach(brand => {
          content.keyMessages.forEach(contentKeyMessage => {
            // Find the keyMessage in the brand by ID
            const brandKeyMessage = brand.keyMessages.find(km =>
              km.ID === contentKeyMessage.keyMessageId
            );
            if (brandKeyMessage) {
              brandKeyMessage.isSelected = true;
              brandKeyMessage.isAutoSelected = true;
            }
          });
        });
      }
    });
  }
 }

unsubscribeToEvents() {
  console.log('unsubscribing product key msgs events');
  this.events.unsubscribe('activities-pane:activitySelected');
  this.events.unsubscribe('user:activity_products_created');
  this.events.unsubscribe('initActivityKeyMessages');
  // this.events.unsubscribe('userStateChanged');
  // this.events.unsubscribe('meetingCompleted');
  this.events.unsubscribe('contentIsAdded');
  this.events.unsubscribe('contentIsRemoved');
  this.events.unsubscribe('savedProductsForCovisitor');
}

filterCompletedActivityProducts(){
  /** Filter only the completed activity products */
  if((this.tempProducts.length > 0 && this.activityService.selectedActivity.isCompleted && this.activityService.selectedActivity.state == MeetingActivityState.Canceled )){
    //this.enableReadonlyViewForMeetings: Removed Condition to fix OMNI-15417.
    this.tempProducts = this.tempProducts.filter(pdt =>  pdt.isSelected);
  }
}
/**
 *
 *
 * @readonly
 * @type {string}
 * @memberof ProductKeyMessagesComponent
 */
// tslint:disable-next-line:prefer-function-over-method
public assignUniqueIdToKeyMessages(productID:string , keyMessageID:string):string{
    return productID +"-"+ keyMessageID;
  }
  /**
   *
   *
   * @param {*} indexes
   * @memberof ProductKeyMessagesComponent
   */
  reorderData(indexes:any){
    //if(this.activityService.selectedActivity.isCompleted) return;
    let element = this.tempProducts[indexes.from];
    this.tempProducts.splice(indexes.from, 1);
    this.tempProducts.splice(indexes.to, 0, element);
    this.tempProducts.map((obj:any , index:any)=>{
      let tempObj:any = obj;
      if(tempObj.isSelected) {
        tempObj['priority'] = index + 1;
      }
      return tempObj
    });
    this.updateProductsFlag = true;
    indexes.complete();
    if (element.isSelected){
      this._saveProduct();
      this.getProductMessageHeader();
    }
    console.log("Reordered" , this.products);
  }

/**
 *
 *
 * @memberof ProductKeyMessagesComponent
 */
slideDown=(event:any , productName:any)=>{
  let sliderQueryList = this.keyMessageSlider.find(slider => slider._elementRef.nativeElement.id === event.target.id);
  sliderQueryList.slidePrev(300 , false);
  }
  /**
   *
   *
   * @memberof ProductKeyMessagesComponent
   */
  slideUp=(event:any , productName:any)=>{
    let sliderQueryList = this.keyMessageSlider.find(slider => (slider._elementRef.nativeElement.id === event.target.id));
    sliderQueryList.slideNext(300 , false);
    this.currentSlider =  sliderQueryList;
  }
  /**
   *
   *
   * @memberof ProductKeyMessagesComponent
   */
  toggleChecked=(ev:MouseEvent , product:any , keyMessage:string)=>{
    //tag the div round by id
    if(!product.isAutoSelected) {
      if(product.isSelected){
        /**
         *  Should we deselect product if use unselects all key message??
         *  Leave it checked for now...
         */
      }else{
        product.isSelected = true;
      }
    }
    //this.events.publish('detectChangesOnActivityDetails');
    this._cd.detectChanges();
  }
  /**
   * Updates the selection state of a product
   *
   * @memberof ProductKeyMessagesComponent
   */
  updateProduct = (event: UIEvent, product: any) => {
    if (
      product.isAutoSelected ||
      this.activityService.selectedActivity.isCompleted ||
      this.activityService.selectedActivity.state == MeetingActivityState.Canceled ||
      this.isReadOnlyJointMeeting ||
      this.enableReadonlyViewForMeetings ||
      this.backgroundUploadInProgress ||
      this.activityService.selectedActivity?.isDiffPosition
    ) return;

    product.isSelected = !product.isSelected;
    product.isAutoSelected = false;

    if (!product.isSelected) {
      product.keyMessages.forEach(key => key.isSelected = false);
    } else {
      this.trackingService.tracking('MeetingProductUpdate', TrackingEventNames.ACTIVITY);
    }

    const tempProductsSelected = this.tempProducts.filter(p => p.isSelected).map(p => p.ID);
    const previouslySavedProductsSelected = this.previouslySavedProducts.filter(p => p.isSelected).map(p => p.ID);

    const arraysEqual = isEqual(tempProductsSelected, previouslySavedProductsSelected);

    this.updateProductsFlag = !arraysEqual;
    this.getProductMessageHeader();
    this.updateFilteredSavedProducts();
    this._cd.detectChanges();
  }
  /**
   * coming soon
   *
   * @memberof ProductKeyMessagesComponent
   */
  async saveProductKeyMessages() {
    //Just an extra check to avoid non authorized data update if HTML faces any manual override
    if (!this.isReadOnlyJointMeeting) {
      if (this.updateProductsFlag) { // this ensures we are not doing the expensive network call to update the meeting DTO object all the time , do it only when needed
        if (this.activityService.selectedActivity instanceof AppointmentActivity || this.activityService.selectedActivity instanceof EmailActivity) {
          const prevProdState = cloneDeep(this.activityService.selectedActivity.products);
          this.previouslySavedProducts = prevProdState.filter(o => o.isSelected || o.isAutoSelected);
          this.activityService.updateSelectedActivityProps({ products: this.tempProducts });
          this.tempProducts = cloneDeep(this.activityService.selectedActivity.products);
          console.log("Captured state of the product model to MSE ", this.activityService.selectedActivity.products);
          if (this.checkIfExternalChannelSelected) {
            let selectedProducts: Array<Brand> = this.tempProducts.filter(prod => prod.isSelected === true)
            if (selectedProducts.length > 1) {
              this.notificationService.notify(this.translate.instant("MULTIPLE_PRODUCTS"), 'Email Activity Detail', 'top', ToastStyle.DANGER);
              return;
            }
          }

          if (this.device.isOffline || this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
            try { // I/O operations needs to be wrap in a try and catch block
              await this.uiService.displayLoader();
              await this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity); // offline saving
              this.uiService.dismissLoader();
              if(this.authService.hasFeatureAction(FeatureActionsMap.SCAN_PRODUCTS_MEETING) && this.scannedProduct){
                this.openSuccessModal(this.scannedProduct);
              }
              this.activityService.updateSelectedActivityProps({
                products: this.activityService.selectedActivity.products.sort((item1: any, item2: any) => {
                  if (item1.priority && item2.priority) {
                    return item1.priority - item2.priority;
                  }
                }),
              });

              this.initDetails();
            } catch (e) {
              this.globalErrorHandler.handleError(new Error(e)); // will implement a Global Error handler
              this.uiService.dismissLoader();
            }

          } else {
            try {
              //updated to reflect the slide share problems CWD-1414
              if (this.activityService.selectedActivity instanceof AppointmentActivity) {
                this.updateProductsFlag = false;
                await this.uiService.displayLoader();
                this.getProductMessageHeader();
                await this.meetingDataService.updateMeetingProductKeyMessages(this.activityService.selectedActivity);
                 // % % % Ability Autoname Subject in Meeting and Procedure Log % % % //
                if(this.secondaryInfoService.isAppointmentSecInfoConfigured){
                  if(this.secondaryInfoService.checkIfSchemaIsConfig('indskr_competitorproduct', SecondaryInfoEntityName.Appointment)) {
                  const subject = this.secondaryInfoService.getSecondaryInfoFormatedTextForAppointment(this.activityService.selectedActivity, SecondaryInfoEntityName.Appointment);
                  this.activityService.updateSelectedActivityProps({ subject });
                  this.syncSubject();
                  }
                } 
                // else if(this.authService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
                //   this.activityService.updateSelectedActivityProps({ subject: [this.translate.instant('MEETING'), this.activityService.selectedActivity.activityTypeName, this.activityService.selectedActivity.meetingOwnerName].filter(Boolean).join(" - ") });
                //   const subject = this.meetingDataService.getMeetingSubject(this.activityService.selectedActivity);
                //   this.activityService.updateSelectedActivityProps({ subject });
                //   this.syncSubject();
                // }
                this.uiService.dismissLoader();
                // % % % Ability Autoname Subject in Meeting and Procedure Log % % % //
              } else if (this.activityService.selectedActivity instanceof EmailActivity) {
                await this.emailService.updateEmailActivityProductKeyMessages(this.activityService.selectedActivity)
              }
              if(this.authService.hasFeatureAction(FeatureActionsMap.SCAN_PRODUCTS_MEETING) && this.scannedProduct){
                this.openSuccessModal(this.scannedProduct);
              }
              this.activityService.updateSelectedActivityProps({
                products: this.activityService.selectedActivity.products.sort((item1: any, item2: any) => {
                  if (item1.priority && item2.priority) {
                    return item1.priority - item2.priority;
                  }
                }),
              });
              this.events.publish('user:activity_products_created', this.activityService.selectedActivity.products);
              this.initDetails();
              //this._activityProductsCreatedEventHandler(this.activityService.selectedActivity.products);
            } catch (e) {
              this.activityService.updateSelectedActivityProps({ products: prevProdState });
              this.events.publish('user:activity_products_created', this.activityService.selectedActivity.products);
              this.uiService.dismissLoader();
              //handled in the patch services!!!
              this.globalErrorHandler.handleError(new Error(e));
            }
          }
        }
        //Removed the toast message
        //this.toast.create({duration: 3000, message:'Product and key messages updated',showCloseButton:true}).present();
      }
      this.updateProductsFlag = false;
      this.updateFilteredSavedProducts();
      this._cd.detectChanges();
    }
  }

  /**
   *
   *
   * @memberof ProductKeyMessagesComponent
   */
  public updatedHighlightedKeyMessage=(ev:MouseEvent , product:any , keyMessage:any)=>{
      //dont use the ev.target creates additonal buttons very wierd
      if(keyMessage.isAutoSelected || this.activityService.selectedActivity.isCompleted || this.activityService.selectedActivity.state == MeetingActivityState.Canceled|| this.isReadOnlyJointMeeting || this.enableReadonlyViewForMeetings || this.backgroundUploadInProgress || this.activityService.selectedActivity?.isDiffPosition) return;
      this.trackingService.tracking('MeetingKeyMessageUpdate', TrackingEventNames.ACTIVITY)
      if(!keyMessage.isSelected) {
        keyMessage.isSelected = true;
        keyMessage.isAutoSelected = false;
      } else {
        keyMessage.isSelected = false;
      }
      this.updateProductsFlag = true;
      this.toggleChecked(ev , product , keyMessage.name);

      this._saveProduct()
      this.getProductMessageHeader();
  }

/**
 *
 *
 * @param {*} ev
 * @memberof ProductKeyMessagesComponent
 */
public slideEnd(ev){
    //console.log("End " ,  ev , "Current Slider " ,this.currentSlider ? this.currentSlider._elementRef.nativeElement.id : "AHAHAHAHA"); // clean it up and push
    if(this.currentSlider){
      this.currentSlider.slidePrev();
    }
  }
/**
 *
 * This a device specific implementation. On swiping to the end all the key messages disappears on device
 * this is the routine to fix that
 * @param {*} event
 * @memberof ProductKeyMessagesComponent
 */
public setCurrentSlider(event:any){
  if(this.device.isNativeApp || this.device.isMobileDevice){

    this.currentSlider =  this.keyMessageSlider.find((slider)=>{
      return slider._elementRef.nativeElement.id === event._elementRef.nativeElement.id
     });

     //}
    }
  }

  /**
 *
 *
 * @memberof ProductKeyMessagesComponent
 */
  async slideChanged() {
    this.currentSlider.getActiveIndex().then((res)=>{
      this.currentIndex = res
      if(this.currentIndex === 2){ // ultimate hack of all time CWD-1559
        this.currentSlider.slideTo(this.currentIndex - 0.6, 300);
      }
    })
  }

  public getProductMessageHeader() {

    let detailsHeaderControls = [];

      if(this.authService.hasFeatureAction(FeatureActionsMap.MEETING_KEY_MESSAGE_SENTIMENT)){
        detailsHeaderControls.push({
          id: 'key-message-sentiment',
          text: this.translate.instant('SENTIMENT'),
          isDisabled: this.backgroundUploadInProgress,
          // iconClass: 'sentiment-icon',
          tooltip: this.translate.instant('SENTIMENT'),
        });
      }
    // When there is only one control, it occupies half the header space and is fully clickable.
    // To prevent this and ensure proper alignment, add a dummy button so there are always at least two controls.
    if (detailsHeaderControls.length == 1) {
      detailsHeaderControls.unshift({
        id: 'dummy-button',
        text: '',
        isDisabled: true,
      });
    }

    this.productsKeyMessagesHeaderModel = {
      id: 'products-key-messages',
      title: this.translate.instant('PRODUCT_KEY_MESSGES'),
      isRequired: this.isProductRequired,
      controls: detailsHeaderControls,
    };
  }

  private openProductList(searchText: string = '') {
    this.updateFilteredSavedProducts();
    this.brandProductsAfterSort = this.sortByPriorityAndName(this.filteredBrands());
    if (this.brandProductsAfterSort) {
      this.sortByPriorityAndName(this.products);

    const listDetail: MainToolTemplateDetail = {
      title: this.translate.instant('PRODUCTS'),
      dividerTitle:this.translate.instant('ALL_PRODUCTS_CAP'),
      isSearchEnabled: true,
      showLeftHeaderButton: true,
      leftHeaderBtnImgSrc: 'assets/imgs/header_cancel.svg',
      leftHeaderBtnText: this.translate.instant('CANCEL'),
      showRightHeaderButton: true,
      rightHeaderBtnImgSrc: 'assets/imgs/header_complete.svg',
      rightHeaderBtnText: this.translate.instant('DONE'),
      orderByPropertyName: 'primaryTextRight',
      hideAllItemsList: false,
      isListSelectionEnabled: true,
      listSelectionType: MainToolTemplateListSelectionType.MULTIPLESELECTION,
      navOptions: { animate: false },
      eventsHandler: (data: any, eventTarget: string, refData: MainToolTemplateDetail)=> this._handleProductComponentEvent(data,eventTarget,refData),
      searchHandler:(text: string) => this._handleProductsComponentSearch(text),
      data: this.brandProductsAfterSort && this.brandProductsAfterSort.map(pro => {
        let isSelected = false;
        let showEndIcon = true;
        const isProductInSaved = this.filteredSavedProducts?.find(sp => sp.ID === pro.ID);
        const isAutoSelected = isProductInSaved && isProductInSaved.isAutoSelected;
        const isProductInContentBrand = this.contentBrand?.find(b => b.ID === pro.ID);

        isSelected = !!isProductInSaved;
        showEndIcon = !(isAutoSelected || isProductInContentBrand);

        return {
          id: pro.ID,
          primaryTextLeft: '',
          secondaryTextLeft: '',
          showEndIcon: showEndIcon,
          mainItemCssClass: 'selector-item',
          isItemSelectedForSelectionView: isSelected,
          endIconType: isSelected?'indegene-selectors-checkmark-icon':'indegene-selectors-add-icon',
          endIconCssClass: isSelected?'checkmark-icon':'add-icon',
          primaryTextRight: pro.name,
          showArrow: false,
          arrowType: '',
          eventOwnerId: this.activityService.selectedActivity.ownerId
        };
      }),
    };
      this.navService.pushWithPageTracking(PageName.MainToolTemplateComponent,
        PageName.NothingSelectedView,
        {viewData:listDetail, isGroupedView:false, searchTextFromComponent: searchText},
        PageName.MainToolTemplateComponent);
    }
  }


  private _handleProductsComponentSearch(text: string): string[] {
    let ids: Array<string> = [];
    if (text.length >= 1) {
      const queryWords = text.toLowerCase().split(' ').filter(word => word.trim() !== '');

        ids = this.brandService.brands
          ? this.brandService.brands
              .filter(p => {
                const title = p.name? p.name.toLowerCase() : '';
                const productNumber = p.productnumber ? p.productnumber.toString().toLowerCase() : '';
                return queryWords.every(word =>
                  title.includes(word) || productNumber.includes(word)
                );
              })
              .map(p => p.ID)
          : [];
    } else {
        ids = this.filteredBrands().map(pro => pro.ID);
    }
    return ids;
  }
  private _handleProductComponentEvent(data: any, eventTarget: string, refData: MainToolTemplateDetail) {
    if (eventTarget && eventTarget === 'RightHeaderButtonClick') {
        if (!this.activityService.selectedActivity.isCompleted && this.activityService.selectedActivity.state != MeetingActivityState.Canceled&& data && data.isDone) {
            if (data.selectedItems && Array.isArray(data.selectedItems) && data.selectedItems.length >= 0) {
                  const foundProduct:Array<Brand> = [];
                  let activityProduct:Array<Brand>  = [];
                  
                  if((this.activityService.selectedActivity as AppointmentActivity)?.activityProducts?.length){
                     activityProduct = (this.activityService.selectedActivity as AppointmentActivity).activityProducts;
                  } else{
                     activityProduct = this.brandService.brands;
                  }
                  data.selectedItems.forEach(item => {
                    activityProduct.forEach(product =>{
                       if(product.ID === item.id){
                          product.isSelected = true;
                          foundProduct.push(product)
                       }
                    });
                    if (foundProduct) {
                      this.tempProducts = uniqBy( sortBy(this.tempProducts.concat(foundProduct), [function(o) { return o.isSelected || o.isAutoSelected; }]),'ID');

                    }
                });

              // To remove products
              let index;
              data.removedItems.forEach(removedItem => {
                index = this.tempProducts.findIndex(activePro => {
                  return (activePro.ID === removedItem.id);
                });
                if (index > -1) {
                  this.tempProducts.splice(index, 1);
                }
              });
            }
            this._saveProduct();
        }
    }
}
  _saveProduct(){
    this.updateProductsFlag = true;
    this.saveProductKeyMessages();
  }
  onSectionHeaderControlClick(id) {
    if (id === 'key-message-sentiment'){
      this.openKeyMessageSentiment.emit(true);
    }
  }

  async scanProduct() {
    const barCodeResponse = await this.barcodescannerService.openBarCodeScanner();

    if (!barCodeResponse || barCodeResponse.status !== BarcodeStatus.SUCCESS) {
      if (barCodeResponse?.status === BarcodeStatus.ERROR_OCCURED) {
        this.notificationService.notify(this.translate.instant('NOT_ABLE_TO_READ_BARCODE'), 'Procuedre', 'top', ToastStyle.DANGER);
      }
      return;
    }

    this.addProductByBarcode(barCodeResponse.data)
  }

  async addProductByBarcode(productNumber) {
    let options;
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      const allProducts = this.brandService.brands;
      let foundProduct = allProducts.find((selectedProduct) => selectedProduct.productnumber === productNumber);

      if (!foundProduct) {
        options = {
          mainImgSrc : 'assets/imgs/round-red-close.svg',
          message : this.translate.instant('PRODUCT_NOT_FOUND'),
          subText: this.translate.instant('PLEASE_CONTACT_SYSTEM_ADMIN'),
        }

        const response = await this.openProductAlert(options);
        if (response && response.data) {
          this.scanProduct();
        }
        return;
      }

      if (allProducts.length) {
        const productSelected = this.tempProducts.find((selectedProduct) => selectedProduct.productnumber === productNumber);
        if (productSelected && productSelected.isSelected) {
          options = {
            mainImgSrc : 'assets/imgs/round-grey-tick.svg',
            message : this.translate.instant('PRODUCT_ADDED_ALREADY'),
            subText: this.translate.instant('PRODUCT_ID') + ` : ${foundProduct.productnumber}`,
            list : [{
              itemAvatarSrc : 'assets/imgs/tools_customer_allocations.svg',
              itemText : `${foundProduct.name}`
            }],
          }
          const response = await this.openProductAlert(options);
          if (response && response.data) {
            this.scanProduct();
          }
          return;
        }

        foundProduct.isSelected = true;
        this.scannedProduct = foundProduct;
        this.tempProducts.push(foundProduct);
        this.tempProducts = uniqBy(sortBy(this.tempProducts, [
          function (o) { return o.isSelected || o.isAutoSelected; }
        ]), 'ID');
        this._saveProduct();
      }
    }
  }

  async openSuccessModal(product){
    let options = {
      mainImgSrc : 'assets/imgs/round-blue-tick.svg',
      message : this.translate.instant('PRODUCT_ADDED'),
      subText: this.translate.instant('PRODUCT_ID') + ` : ${product?.productnumber}`,
      list : [{
        itemAvatarSrc : 'assets/imgs/tools_customer_allocations.svg',
        itemText : `${product?.name}`
      }],
    }
    const response = await this.openProductAlert(options);
    if (response && response.data) {
      this.scanProduct();
      return;
    }
  }

  async openProductAlert(options:any) {
    const modal = await this.modalCtrl.create({
      component: OmniAlertComponent,
      cssClass: 'omni-alert-modal',
      componentProps: {
        inputOptions: {
          ...options,
          cancelBtnText : this.translate.instant('CLOSE'),
          confirmBtnText : this.translate.instant('SCAN_BARCODE')
        }
      }
    });
    await modal.present();

    return await modal.onDidDismiss().then((data) => {
      this.scannedProduct = null;
      return data;
    });

  }
  syncSubject(){
    let payload = new UpdateMeetingPayload(
      this.activityService.selectedActivity.subject,
      this.activityService.selectedActivity.location,
      this.activityService.selectedActivity.scheduledStart,
      this.activityService.selectedActivity.scheduledEnd
    );
     this.meetingDataService.updateMeeting(this.activityService.selectedActivity as AppointmentActivity, payload, true);

  }
  // Only introduced to handle specific sccenario of making appointment editable in calendar view
  public get enableReadonlyViewForMeetings():boolean {
    let flag = this.activityService.teamViewActive;
    if(this.activityService.isMyUserSelectedInTeamView && this.agendaFooterService.actSegment == 'week' && this.activityService.selectedActivity && this.activityService.selectedActivity instanceof AppointmentActivity && this.activityService.activities.some(a=> a.ID == this.activityService.selectedActivity.ID)){
      flag = false;
    }
    return flag;
  }

  private getAvailableProducts() {
      this.brandProductsAfterSort = this.sortByPriorityAndName(this.filteredBrands());

      const selectableProducts = this.brandProductsAfterSort;

      return selectableProducts.map(sp => ({
        id: sp.ID,
        title: sp.name,
        image: '',
        refObject: sp,
        endIcon: undefined,
        hideAvatarOrInitial: true,
      }));
    }

  async setProductSourceData() {
      this.productSourceData = this.getAvailableProducts();
    }

  async initProductsSearchField() {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const selectedProducts = this.getSelectedProducts();
    const endIcons = [
      {
        iconName: 'searchblue', overRideDisabledProperty: false
      },
      { 
        iconName: 'expandblue', overRideDisabledProperty: false 
      }
    ];
    
    if (this.authService.hasFeatureAction(FeatureActionsMap.SCAN_PRODUCTS_MEETING)) {
      endIcons.push(
        { 
          iconName: 'barcode', overRideDisabledProperty: false 
        }
      );
    }

    this.setProductSourceData();

    const isFormDisabled = this.enableReadonlyViewForMeetings 
      || this.isReadOnlyJointMeeting 
      || meeting.state === MeetingActivityState.Completed 
      || meeting.state === MeetingActivityState.Completed
      || meeting.state === MeetingActivityState.Canceled;

    this.productsSearchField = {
      label: '',
      inputText: '',
      id: 'product-search-field',
      formFieldType: FormFieldType.LIST,
      isReadOnly: true,
      showArrow: true,
      isHidden: false,
      isRequired: false,
      isEmptyRequiredField: false,
      isDisabled: isFormDisabled,
      errorMessage: '',
      customPlaceholderLabel: this.translate.instant('SEARCH_PRODUCT_TO_ADD'),
      modalConfiguration: {
        searchTitle: this.translate.instant('SEARCH_PRODUCTS'),
        selectedTitle: this.translate.instant('SELECTED_PRODUCTS'),
        titleEndIcon: 'expandblue',
        searchInputConfig: {
          label: this.translate.instant('PRODUCTS'),
          placeholder: this.translate.instant('TYPE') + '...'
        },
        showSearch: true,
      },
      filterMethod: this.filterProductsData.bind(this),
      endIcons,
      sections: await this.generateProductSections(),
      selectedData: selectedProducts,
      hideInlineChip: true,
      isSearchKeyRetain: true,
      showDropDownOnFocus : this.productSourceData.length <= (this.device.isMobileDevice ? 5 : 10) ? true : false,
      eventHandler: (id: string, event, eventName, data) => {
        if (data && eventName == 'item-click') {
          const isAlreadySelected = meeting.products.some((product) => product.ID === data.id && product.isSelected)
          || this.tempProducts.some((product) => product.ID === data.id && product.isSelected);
          if (!isAlreadySelected) {
            this.addAndSaveProductFromSearchField(event, data);
          }
        } else if (data && eventName === 'closebutton') {
          this.removeSavedProductFromSearchField(event, data);
        }
      },
    };
  }

  filterProductsData(query: string): any[] {
    this.setProductSourceData();
    const queryWords = query.toLowerCase().split(' ').filter(word => word.trim() !== '');

    const filteredProducts = this.productSourceData
      .filter((p: any) => {
        const title = p.title.toLowerCase();
        const keyMessages = p.refObject.keyMessages ? p.refObject.keyMessages.map(km => km.name.toLowerCase()) : [];
        const productNumber = p.refObject.productnumber ? p.refObject.productnumber.toString().toLowerCase() : '';
        const result = queryWords.every(word => 
          title.includes(word) || keyMessages.some(km => km.includes(word)) || productNumber.includes(word)
        );
        return result;
      }).filter((p: any) => !this.filteredSavedProducts?.some((sp: any) => sp.ID === p.id));

    return filteredProducts;
  }

  onFieldControlClick(event) {
    if (!event) return;
    
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const isFormDisabled = this.enableReadonlyViewForMeetings 
      || this.isReadOnlyJointMeeting 
      || meeting.state === MeetingActivityState.Completed 
      || meeting.state === MeetingActivityState.Completed
      || meeting.state === MeetingActivityState.Canceled;
    
    if (isFormDisabled) return;

    if (event == 'expandblue' || event?.id == 'expandblue' || event?.id == 'view-all') {
      let searchText = '';
      if (event?.id == 'view-all' && event?.text) {
        searchText = event.text;
      } else if (event?.id == 'expandblue' && event?.text) {
        searchText = event?.text;
      }
      this.openProductList(searchText);
    } else if (event == "barcode") {
      this.scanProduct();
    }
  }

  async generateProductSections(): Promise<Section[]> {
    const selectedProducts = this.getSelectedProducts();
    return this.createSections(selectedProducts, 'SELECTED', 'AL_RESULTS', '', false);
  }
  
  private createSections(
    selectedData: any[],
    selectedTitleKey: string,
    resultsTitleKey: string,
    lessThanResultButtonKey: string,
    showLessThanResultButton: boolean = true
  ): Section[] {
    return [
      {
        id: 'selected',
        title: this.translate.instant(selectedTitleKey),
        showCountOnTitle: true,
        maxResultsView: this.device.isMobileDevice ? 5 : 10,
        bottomButtonShow: true,
        expand: false,
        showBottomButton: true,
        hideAvatarOrInitial: true,
        bottomButtonConfig: {
          exceedMaxResultButton: {
            id: 'view-all',
            label: this.translate.instant('VIEW_MORE'),
          },
        },
        data: selectedData,
      },
      {
        id: 'results',
        title: this.translate.instant(resultsTitleKey),
        showFilteredData: true,
        showCountOnTitle: true,
        maxResultsView: this.device.isMobileDevice ? 5 : 10,
        bottomButtonShow: true,
        expand: true,
        showBottomButton: true,
        hideAvatarOrInitial: true,
        bottomButtonConfig: {
          exceedMaxResultButton: {
            id: 'view-all',
            label: this.translate.instant('VIEW_MORE'),
          },
          lessThanResultButton: showLessThanResultButton ? {
            id: 'show-other',
            label: this.translate.instant(lessThanResultButtonKey),
          } : undefined,
        },
        data: [],
      },
    ];
  }

  private getSelectedProducts() {
    this.updateFilteredSavedProducts();
    if (this.filteredSavedProducts.length === 0) return [];
    
    return this.sortByPriorityAndName(this.filteredSavedProducts, false).map(product => (
      {
        id: product.ID,
        title: product.name.trim(),
        image: '',
        refObject: product,
        endIcon: product.isSelected && !product.isAutoSelected ? 'closebutton' : undefined,
        hideAvatarOrInitial: true
      }
    ));
  }

  public removeSavedProduct(event, product) {
    if (!event) return;

    const selectedId = product?.ID || '';
    this.updateProduct(event, product);
    this._saveProduct();
  }

  private addAndSaveProductFromSearchField(event, product) {
    if (!event) return;
    const selectedId = product?.id || '';
    const brands: Array<Brand> = cloneDeep(this.filteredBrands());
    const selectedProduct = brands.find(p => p.ID === selectedId);
    
    if(!selectedProduct) return;
    
    selectedProduct.isSelected = true;
    this.tempProducts.push(selectedProduct);
    this.tempProducts = uniqBy(sortBy(this.tempProducts, [function (o) { return o.isSelected || o.isAutoSelected; }]), 'ID');
    this._saveProduct();
  }

  private removeSavedProductFromSearchField(event, product) {
    if (!event) return;
    
    const selectedId = product?.id || '';
    const selectedProduct = this.tempProducts.find(p => p.ID === selectedId);
    
    if(!selectedProduct) return;
    
    this.updateProduct(event, selectedProduct);
    this._saveProduct();
  }

  private updateFilteredSavedProducts() {
    this.filteredSavedProducts = this.tempProducts.filter(p => p.isSelected || p.isAutoSelected);
    if (!isEmpty(this.filteredSavedProducts)) {
      this.filteredSavedProducts = this.sortByPriorityAndName(this.filteredSavedProducts, false);
    }
  }

  /**
   * Parses BU_ACTIVITY_GA_PRODUCT_SORT_ORDER config and returns a Map<GUID, order>.
   * Config JSON: [{ "id": "<guid>", "order": 1 }, { "id": "<guid>", "order": 2 }, ...]
   * PKM matches by Brand.ID; IAO matches by sampleSKUId — unmatched GUIDs are ignored.
   */
  private _getProductSortOrderMap(): Map<string, number> {
    if (this._productSortOrderMap) return this._productSortOrderMap;
    this._productSortOrderMap = new Map<string, number>();
    try {
      const configValue = this.authService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_ACTIVITY_GA_PRODUCT_SORT_ORDER);
      if (configValue && typeof configValue === 'string') {
        const parsed = JSON.parse(configValue);
        if (Array.isArray(parsed)) {
          parsed
            .filter((entry: any) => entry?.id)
            .forEach((entry: any) => {
              this._productSortOrderMap.set(String(entry.id).trim().toLowerCase(), entry.order ?? 0);
            });
        }
      }
    } catch (e) {
      console.warn('Failed to parse BU_ACTIVITY_GA_PRODUCT_SORT_ORDER config', e);
    }
    return this._productSortOrderMap;
  }

  private sortByPriorityAndName(products: Brand[], useConfigOrder: boolean = true): Brand[] {
    const configOrder = useConfigOrder ? this._getProductSortOrderMap() : new Map<string, number>();
    return products.sort((a, b): number => {
      // Config sort order takes highest precedence
      if (configOrder.size > 0) {
        const aConfig = configOrder.has(a.ID?.toLowerCase());
        const bConfig = configOrder.has(b.ID?.toLowerCase());
        if (aConfig && bConfig) {
          return configOrder.get(a.ID.toLowerCase()) - configOrder.get(b.ID.toLowerCase());
        }
        if (aConfig) return -1;
        if (bConfig) return 1;
      }
      // Then sort by priority if both have it
      if (a.priority != null && b.priority != null) {
        if (a.priority > b.priority) return 1;
        if (a.priority < b.priority) return -1;
      } else if (a.priority != null) {
        return -1;
      } else if (b.priority != null) {
        return 1;
      }
      // If priorities are equal or missing, sort by name
      const aName = (a.name?.toLowerCase() || '');
      const bName = (b.name?.toLowerCase() || '');
      if (aName > bName) return 1;
      if (aName < bName) return -1;
      return 0;
    });
  }

  private filteredBrands(): Brand[] {
    if (isEmpty(this.brandService.brands)) {
      return [];
    }
    return this.brandService?.brands?.filter(b=> !b.productApplicability.length || b.productApplicability.includes('100000000'));
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}
